<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-interval="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row>
      <b-col cols="12">
        <b-alert
          variant="info"
          show
          class="mb-1"
        >
          <b-card-body class="py-75 px-1">
            <feather-icon
              icon="InfoIcon"
              size="15"
            />
            <span class="ml-50 small">
              «درآمد منتسب» مبلغ کل سفارش‌هایی است که با این کد ثبت شده‌اند —
              نه سودی که کد ایجاد کرده. «بازده» نسبت همین درآمد به تخفیف داده‌شده است.
            </span>
          </b-card-body>
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="performance"
          title="عملکرد کدهای تخفیف"
          :subtitle="rangeLabel"
          label-title="کد تخفیف"
          :loading="loading('performance')"
          :route-for="couponRoute"
          empty-text="در این بازه از هیچ کد تخفیفی استفاده نشده است"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BAlert, BCardBody } from 'bootstrap-vue'
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportCoupons',
  components: { BAlert, BCardBody },
  mixins: [reportMixin],
  data() {
    return {
      performance: null,
    }
  },
  computed: {
    compareLabel() {
      return this.performance && this.performance.CompareRange
        ? this.performance.CompareRange.Label
        : null
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.fetchReport('performance', this.$api.report.couponPerformance)
    },

    couponRoute(row) {
      return row.Id ? { name: 'updatecoupon', params: { id: row.Id } } : null
    },
  },
}
</script>
